export const SURVEY_TYPE = {
	CSAT: 1
};
